export const addonFeatures = [
    "DeviceManagement",
    "ProductManagement",
    "LicenseRevocation",
    "SupportService",
    "ClientManagement",
] as const;

export const isAddonFeature = (feature: string): boolean => (addonFeatures as readonly string[]).includes(feature);

export const getFeature = (featureName: API.Feature["feature"], features: ReadonlyArray<API.Feature>): API.Feature => {
    const feature = features?.find((f) => f.feature === featureName);
    return feature ?? { feature: featureName, max: 0 };
};

export const getBarValue = (usedCount: number, total: number) => {
    if (total === Infinity) {
        return 100;
    }
    if (total === 0) {
        return 0;
    }
    return (usedCount / total) * 100;
};
